import React from 'react';
import './plusButton.scss';
import { ReactComponent as Plus } from '../../assets/plus.svg';

const PlusButton: React.FC = () => (
  // const handleClick = (
  //   event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  // ) => {
  //   event.stopPropagation();
  //   onClick();
  // };

  <div className="plusButton">
    <Plus className="plusIcon" />
  </div>
);
export default PlusButton;
